import { EnumBase } from 'hay-core-react';
class TarefaAgendadaStatusEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.tarefaagendada.status.emexecucao',
                'main.tarefaagendada.status.sucesso',
                'main.tarefaagendada.status.erro',
            ],
            'main.tarefaagendada.status.emexecucao'
        );
    }
}

const instance = new TarefaAgendadaStatusEnum();
export default instance;
